import defaultState from "./state";

const filtroBusquedaRCDetalleReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "FILTROBUSQUEDARCDETALLE/LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "FILTROBUSQUEDARCDETALLE/CARGA_RECARGOS_CONVENIDOS_EXCEP": {
      return Object.assign({}, state, {
        recargosConvenidosExcep: action.recargosConvenidosExcep,
        busquedarecargos: true,
        loading: false,
      });
    }

    case 'FILTROBUSQUEDARCDETALLE/UPDATE_DETAIL_TECNIQUES': {
      return Object.assign({}, state, {
        recargosConvenidosExcep: action.recargosConvenidosExcep,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaRCDetalleReducer;
